import { required, email } from "@/validation/validators";

export const previewInvitationSchema = () => ({
    email: { email, required },
});
